import Enhancer from '../enhancer';
import EnhancerApp from '../enhancer-app';
import { wrapElement } from '../utils/dom';

export default class ArticleBody extends Enhancer {
	init() {

		// Add classes to make iFrames responsive
		const responsiveIframe = (src) => {
			this.getAll(`iframe[src*=${src}]`).forEach(video => {
				const wrapper = video.parentNode;
				video.classList.add('embed-item');
				wrapper.classList.add('ratio', 'ratio-16x9');
			});
		}

		responsiveIframe("youtube");
		responsiveIframe("vimeo");

		this.getAll('table').forEach(table => {
			const wrapper = table.parentNode;

			if (wrapper.classList.contains('table-responsive')) {
				return;
			}

			// create table wrapper
			const tableWrapper = document.createElement('div');
			tableWrapper.className = 'table-responsive';

			wrapElement(table, tableWrapper);
		});
	}
}

EnhancerApp.register('ArticleBody', ArticleBody);